/**
 * @generated SignedSource<<061e6c3eb815973f1f69421999f98c64>>
 * @relayHash 71263e9d8d767cf4a50cd3767e551b5f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 891a1c005f0e8376e190bd17e683381d59384111816bdb8be2da1dcad7446f15

import type { ConcreteRequest } from 'relay-runtime';
export type useAttachmentsMacroDataQuery$variables = {
  contentId: string;
  first?: number | null;
  includeAttachmentActionContext: boolean;
  offset?: number | null;
};
export type useAttachmentsMacroDataQuery$data = {
  readonly singleContent: {
    readonly attachments: {
      readonly count: number | null;
      readonly nodes: ReadonlyArray<{
        readonly extensions: ReadonlyArray<{
          readonly key: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly history: {
          readonly createdBy: {
            readonly accountId?: string | null;
            readonly displayName?: string | null;
            readonly profilePicture?: {
              readonly path: string;
            } | null;
          } | null;
          readonly createdDate: string | null;
        } | null;
        readonly id: string | null;
        readonly labels: {
          readonly nodes: ReadonlyArray<{
            readonly id: string | null;
            readonly name: string | null;
          } | null> | null;
        } | null;
        readonly links: {
          readonly download: string | null;
        } | null;
        readonly operations: ReadonlyArray<{
          readonly operation: string | null;
        } | null> | null;
        readonly title: string | null;
        readonly type: string | null;
        readonly version: {
          readonly by: {
            readonly accountId?: string | null;
            readonly displayName?: string | null;
            readonly profilePicture?: {
              readonly path: string;
            } | null;
          } | null;
          readonly message: string | null;
          readonly number: number | null;
          readonly when: string | null;
        } | null;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly id: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
    } | null> | null;
    readonly space?: {
      readonly id: string | null;
      readonly key: string | null;
    } | null;
    readonly subType?: string | null;
    readonly type?: string | null;
  } | null;
};
export type useAttachmentsMacroDataQuery = {
  response: useAttachmentsMacroDataQuery$data;
  variables: useAttachmentsMacroDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": 250,
  "kind": "LocalArgument",
  "name": "first"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAttachmentActionContext"
},
v3 = {
  "defaultValue": 0,
  "kind": "LocalArgument",
  "name": "offset"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Literal",
    "name": "status",
    "value": [
      "current",
      "draft",
      "archived"
    ]
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "ScalarField",
  "name": "type"
},
v7 = {
  "kind": "ScalarField",
  "name": "key"
},
v8 = {
  "condition": "includeAttachmentActionContext",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    (v6/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "Space",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v5/*: any*/),
        (v7/*: any*/)
      ]
    }
  ]
},
v9 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    }
  ]
},
v10 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  }
],
v11 = {
  "kind": "ScalarField",
  "name": "count"
},
v12 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v13 = {
  "kind": "ScalarField",
  "name": "title"
},
v14 = {
  "concreteType": "KeyValueHierarchyMap",
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "name": "number"
},
v16 = {
  "kind": "ScalarField",
  "name": "when"
},
v17 = {
  "kind": "ScalarField",
  "name": "message"
},
v18 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/),
    {
      "concreteType": "Icon",
      "kind": "LinkedField",
      "name": "profilePicture",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "path"
        }
      ]
    }
  ],
  "type": "KnownUser"
},
v21 = {
  "kind": "InlineFragment",
  "selections": [
    (v18/*: any*/),
    (v19/*: any*/)
  ],
  "type": "UnknownUser"
},
v22 = [
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "createdDate"
},
v24 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "PaginatedLabelList",
  "kind": "LinkedField",
  "name": "labels",
  "plural": false,
  "selections": [
    {
      "concreteType": "Label",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "name"
        }
      ]
    }
  ],
  "storageKey": "labels(first:100)"
},
v25 = {
  "concreteType": "LinksDownloadEdituiWebuiContextSelfTinyuiCollectionBase",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "download"
    }
  ]
},
v26 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  },
  (v20/*: any*/),
  (v21/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useAttachmentsMacroDataQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "args": (v10/*: any*/),
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v13/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      }
                    ]
                  },
                  (v24/*: any*/),
                  (v9/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useAttachmentsMacroDataQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "singleContent",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "args": (v10/*: any*/),
            "concreteType": "PaginatedContentList",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v12/*: any*/),
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v13/*: any*/),
                  (v6/*: any*/),
                  (v14/*: any*/),
                  {
                    "concreteType": "Version",
                    "kind": "LinkedField",
                    "name": "version",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "by",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      }
                    ]
                  },
                  {
                    "concreteType": "History",
                    "kind": "LinkedField",
                    "name": "history",
                    "plural": false,
                    "selections": [
                      (v23/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": (v26/*: any*/)
                      }
                    ]
                  },
                  (v24/*: any*/),
                  (v9/*: any*/),
                  (v25/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "71263e9d8d767cf4a50cd3767e551b5f",
    "id": "891a1c005f0e8376e190bd17e683381d59384111816bdb8be2da1dcad7446f15",
    "metadata": {},
    "name": "useAttachmentsMacroDataQuery",
    "operationKind": "query",
    "text": "query useAttachmentsMacroDataQuery($contentId:ID!,$first:Int=250,$offset:Int=0,$includeAttachmentActionContext:Boolean!){singleContent(id:$contentId,status:[\"current\",\"draft\",\"archived\"]){id,type@include(if:$includeAttachmentActionContext)\n    subType@include(if:$includeAttachmentActionContext)\n    space@include(if:$includeAttachmentActionContext){id,key},operations{operation},attachments(first:$first,offset:$offset){count,pageInfo{hasNextPage},nodes{id,title,type,extensions{key,value},version{number,when,message,by{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{accountId,displayName}}},history{createdDate,createdBy{__typename,...on KnownUser{accountId,displayName,profilePicture{path}},...on UnknownUser{accountId,displayName}}},labels(first:100){nodes{id,name}},operations{operation},links{download}}}}}"
  }
};
})();

(node as any).hash = "52218f94ae19a475dc8828c3ba4854a3";

export default node;
